// Question-set bindings. Mirrors iOS QuestionSetsEndpoints + /question-sets/*.
import { api } from "./client";
import type { CheatsheetMarks, QuestionSetRead, QuestionSetSummary } from "./library-types";

export function listQuestionSets(archived = false): Promise<QuestionSetSummary[]> {
  return api.get<QuestionSetSummary[]>("/question-sets/", { query: { archived } });
}

export function getQuestionSet(id: string): Promise<QuestionSetRead> {
  return api.get<QuestionSetRead>(`/question-sets/${encodeURIComponent(id)}`);
}

export function archiveQuestionSet(id: string, archived: boolean): Promise<unknown> {
  return api.patch(`/question-sets/${encodeURIComponent(id)}/archive`, { archived });
}

export function updateCheatsheetMarks(setId: string, marks: CheatsheetMarks): Promise<void> {
  return api.patch<void>(`/question-sets/${encodeURIComponent(setId)}/cheatsheet-marks`, { marks });
}

/**
 * Deep-duplicate a set the caller can read (owner / classmate / friend) into
 * their own library as a fresh private copy. Returns the new set's summary.
 */
export function copyQuestionSet(id: string): Promise<QuestionSetSummary> {
  return api.post<QuestionSetSummary>(`/question-sets/${encodeURIComponent(id)}/copy`);
}

/** A set a friend shared directly with me (the "Shared with me" inbox). */
export interface SharedWithMeItem {
  share_id: string;
  resource_id: string;
  resource_title: string;
  sender_user_id: string;
  sender_display_name: string;
  item_count: number;
  bulk_count: number;
  created_at: string;
}

export function sharedWithMe(): Promise<SharedWithMeItem[]> {
  return api.get<SharedWithMeItem[]>("/question-sets/shared-with-me");
}
